module.exports = __webpack_public_path__ + "static/media/pin-form-popup-image-en.d744b219.png";